module.exports = __webpack_public_path__ + "static/media/productfeaturesmart.abda4859.png";